import { Modal, Typography } from 'antd';

import { Button } from '@shared/components';

const { Text } = Typography;

const SubsidyForServicesModal = () => {
  const onClose = () => {
    Modal.destroyAll();
  };

  return (
    <div className="flex flex-col gap-y-6">
      <div className="flex flex-col items-center gap-y-2 text-center">
        <Text className="px-4 text-base font-bold">Subsidies for Services and Other Medications^</Text>
        <div className="flex flex-col gap-y-2 text-center">
          <Text className="text-sm">
            Cannot be used to offset the remaining co-payment after subsidies for the selected chronic medications.
          </Text>

          <Text className="text-center text-xs text-functional-iron">
            ^Refers to all other medications which are not defined in the Healthier SG Medication List.
          </Text>
        </div>
      </div>

      <div className="flex items-center justify-center">
        <Button className="w-full" onClick={onClose}>
          OK
        </Button>
      </div>
    </div>
  );
};

export default SubsidyForServicesModal;
